import { render, staticRenderFns } from "./NbaTopPlayer.vue?vue&type=template&id=0cbbbd41&scoped=true"
import script from "./NbaTopPlayer.vue?vue&type=script&lang=js"
export * from "./NbaTopPlayer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cbbbd41",
  null
  
)

export default component.exports